import { type PropsWithChildren } from 'react';

import { InAppNotificationSocketContext } from '@/contexts/inAppNotification';
import { useInAppNotificationSocket } from '@/hooks/inAppNotification';

/**
 * Holds the app's single notification socket open.
 *
 * Mounted once, above the routes, so the connection survives navigation and is
 * not duplicated by however many components read notifications. It renders
 * nothing of its own; with the feature flag off it is a pass-through and no
 * socket is opened at all.
 */
export const InAppNotificationsProvider = ({ children }: PropsWithChildren) => {
  const value = useInAppNotificationSocket();

  return (
    <InAppNotificationSocketContext.Provider value={value}>
      {children}
    </InAppNotificationSocketContext.Provider>
  );
};
